<template>
  <div @mouseover="mouseEnter = true" @mouseleave="mouseEnter = false" class="temporary-position">
    <md-card class="snew-member-card" :class="[{ 'md-elevation-20': mouseEnter }]">
      <div class="card-header">
        <md-avatar>
          <router-link :to="`/s-app/group-page/${post.group.id}`">
            <img :src="getGroupImagePath(post.group)" alt="Group" />
          </router-link>
        </md-avatar>
        <span class="md-title">New group message</span>
        <img src="../../../public/img/group-card-header.png" alt="card-header-img" class="card-header-image" />
      </div>
      <p class="time-ago">{{ getTimeAgo(post.createdAt) }}</p>

      <md-card-content class="welcome-content">
        <div>
          <p class="post-description">
            <span class="bold">{{ getUserName(post.author) }}</span>
            posted a new message on
            <span class="bold">{{ post.group.name }}</span>
          </p>
          <div class="group-connection">
            <router-link :to="`/s-app/profile-page/${post.author.id}`">
              <SUserAvatar :myUser="post.author" size="large" :isProfileAvatar="false" />
            </router-link>
            <md-icon class="ml-2 mr-2 arrow-forward">arrow_forward</md-icon>
            <router-link :to="`/s-app/group-page/${post.group.id}`">
              <md-avatar class="md-large">
                <img :src="getGroupImagePath(post.group)" alt="Group" />
              </md-avatar>
            </router-link>
          </div>
        </div>
        <div class="post-text">
          <p class="text-center">"{{ post.post }}"</p>
        </div>
        <div>
          <p class="coments-count">This post has ({{ post.commentsCount }}) comments</p>
          <div class="post-actions">
            <input type="text" placeholder="Reply post" class="reply-post" v-model="text" @keyup.enter.exact="sendComment"/>
            <SButtonMaterial buttonType="button" class="send-button" color="secondary" textColor="white"
              materialClass="dense" iconWithoutText="send" iconColor="white" @button="sendComment"/>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment";
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
export default {
  name: "SNewPostGroup",
  props: ["post"],
  mixins: [UserHelperVue, GroupHelperVue],
  data() {
    return {
      mouseEnter: false,
      text: '',
    };
  },
  components: {
    SButtonMaterial,
    SUserAvatar,
  },
  methods: {
    getTimeAgo(time) {
      if (time) {
        return moment(time).fromNow();
      } else {
        return "";
      }
    },
    sendComment() {
      if (!this.text) return
      try {
        this.sendGroupComment({
          comment: this.text, 
          groupMessage: {
            group: { id: this.post.group.id},
            id: this.post.author.id
          },
        });
        this.text = "";
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}

.time-ago {
  margin: 0;
  padding: 3px 10px;
  color: rgba(0, 0, 0, 0.443);
  font-weight: bold;
}

.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}

.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px;
  z-index: 2;
}

.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 75%;
}

.bold {
  font-weight: bold;
}

.post-description {
  text-align: center;
  font-size: 18px;
  margin: 0;
  padding: 0 39px;
}

.arrow-forward {
  font-size: 30px !important;
  font-weight: bold;
}

.coments-count {
  text-align: center;
  color: $secondary;
  font-weight: bold;
}

.post-actions {
  display: flex;
  align-items: center;
}

.reply-post {
  border-radius: 50px;
  padding: 0.8rem;
}

.send-button {
  border-radius: 50%;
  min-width: unset;
  height: 42px;
  width: 55px;
}

.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}

.snew-member-card {
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 558px;
  margin-bottom: 2rem;
  color: $black !important;
  border-radius: 4px;
  border: 1px solid $grey;
}

.welcome-content {
  min-height: 88%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.group-connection {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.group-connection i {
  color: $black !important;
}

.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}

.md-title a {
  color: $black;
}

.md-title a:hover {
  color: $primary;
}

@media screen and (max-width: 560px) {
  .temporary-position {
    display: flex;
    justify-content: center;
  }

  .md-large {
    width: 80px !important;
    height: 80px !important;
    min-width: 80px !important;
    min-height: 80px !important;
  }
}
</style>
